<script>
  import { onMount } from 'svelte';
  import { navigate } from 'svelte-routing';

  onMount(() => {
    const params = new URLSearchParams(window.location.search);
    const query = params.toString();
    const target = query ? `/settings/subscription?${query}` : '/settings/subscription';
    navigate(target);
  });
</script>

<div class="flex justify-center items-center py-16">
  <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
  <span class="ml-3 text-gray-600">Redirecting to settings...</span>
</div>
